import { Inject, Injectable } from '@angular/core';
import { fromEvent, interval, merge } from 'rxjs';
import { share, startWith, switchMap, take, throttleTime } from 'rxjs/operators';
import { WINDOW } from '../providers/window.providers';

const IDLE_TIMEOUT = 180000; // 3 minutes

@Injectable({
  providedIn: 'root'
})
export class IdleService {

  constructor(@Inject(WINDOW) private window: Window) { }

  private readonly activityEvents$ = merge(
    fromEvent(this.window, 'pointerdown'),
    fromEvent(this.window, 'pointerup'),
    fromEvent(this.window, 'touchmove'),
    fromEvent(this.window, 'wheel')
  );

  readonly idleDetected$ = this.activityEvents$.pipe(
    startWith(0),
    throttleTime(1000),
    switchMap(_ =>
      interval(IDLE_TIMEOUT)
    ),
    take(1),
    share()
  );

}
